<template>
  <v-dialog
    content-class="dialog__term_and_conditions"
    v-model="noVersionAccepted"
    scrollable
    persistent
    :max-width="$vuetify.breakpoint.mdAndUp ? 960 : 600"
  >
    <v-card>
      <v-toolbar fixed elevation="0">
        <v-toolbar-title class="secondary--text text-h5 font-weight-black">{{
          $t(
            'portal.login.dialog_terms_and_conditions.labels.label_terms_and_conditions_card_title'
          )
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" @click="cancelTermsConditionsModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text class="terminos_and_conditions" ref="tyc_content" v-html="htmlText" />

      <v-divider></v-divider>
      <v-card-actions>
        <v-container fluid class="py-0">
          <v-row>
            <v-col cols="12">
              <v-form
                ref="termsAndConditionForm"
                v-model="validTermsForm"
                lazy-validation
              >
                <div class="primary--text text-right">
                  {{
                    $t(
                      'portal.login.dialog_terms_and_conditions.labels.label_scroll_to_bottom'
                    )
                  }}
                </div>
                <v-checkbox
                  v-model="checkboxServiceTerms"
                  :rules="[rules.required]"
                  :disabled="!scrolledToBottom"
                  :label="
                    $t(
                      'portal.login.dialog_terms_and_conditions.labels.label_service_terms_checkbox'
                    )
                  "
                  hide-details="auto"
                  required
                ></v-checkbox>

                <v-checkbox
                  v-model="checkboxPrivacyPolicy"
                  :rules="[rules.required]"
                  :disabled="!scrolledToBottom"
                  :label="
                    $t(
                      'portal.login.dialog_terms_and_conditions.labels.label_privacy_policy_checkbox'
                    )
                  "
                  hide-details="auto"
                  required
                ></v-checkbox>
                <div class="text-center text-md-right mt-6 mt-md-0">
                  <v-btn
                    rounded
                    outlined
                    class="secondary--text"
                    @click="cancelTermsConditionsModal"
                    >{{
                      $t(
                        'portal.login.dialog_terms_and_conditions.labels.label_terms_and_conditions_cancel_button'
                      )
                    }}</v-btn
                  >
                  <v-btn
                    rounded
                    color="tertiary"
                    :disabled="verifyConditions"
                    class="ml-4 white--text"
                    @click="acceptNewVersionTermsConditions"
                    >{{
                      $t(
                        'portal.login.dialog_terms_and_conditions.labels.label_terms_and_conditions_accept_button'
                      )
                    }}</v-btn
                  >
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/plugins/i18n'
export default {
  props: {
    noVersionAccepted: {
      type: Boolean
    },
    htmlText: {
      type: String
    }
  },
  data() {
    return {
      validTermsForm: true,
      checkboxServiceTerms: false,
      checkboxPrivacyPolicy: false,
      scrolledToBottom: false,
      rules: {
        required: value =>
          !!value ||
          i18n.t(
            'portal.login.dialog_terms_and_conditions.rules.checkbox_required'
          )
      }
    }
  },
  methods: {
    cancelTermsConditionsModal() {
      this.noVersionAccepted = !this.noVersionAccepted
      this.$emit('cancelTermsConditionsModal')
    },
    acceptNewVersionTermsConditions() {
      if (this.$refs.termsAndConditionForm.validate())
        this.$emit('versionAcceptTermsConditions')
    },
    scroll() {
      const el = this.$refs.tyc_content
      el.onscroll = () => {
        const bottom = el.scrollHeight - el.offsetHeight
        // La reducción al 99% del value bottom se realiza para asegurar la habilitación de los controles checkbox
        // dado que se dio un escenario sobre SO:Windows con zoom y escalado donde no funcionaba correctamente si el valor de bottom era puro
        if (Math.ceil(el.scrollTop) >= bottom * 0.99)
          this.scrolledToBottom = true
      }
    }
  },
  mounted() {
    this.scroll()
  },
  computed: {
    verifyConditions() {
      if (this.checkboxServiceTerms && this.checkboxPrivacyPolicy) {
        return false
      } else return true
    }
  }
}
</script>

<style>
.dialog__term_and_conditions {
  overflow: hidden !important;
}
@media (min-width: 600px) {
  .terminos_and_conditions div {
    width: initial !important;
    margin-bottom: 0px !important;
    margin-top: 35pt;
    margin-left: 85pt;
    margin-right: 85pt;
  }
}
@media (max-width: 600px) {
  .terminos_and_conditions div {
    width: 100% !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}
</style>
